<div class="table">
  <div
    *ngIf="view$ | async as view"
    [hidden]="!!isEmpty || config.dataSource.filteredData.length === 0"
  >
    <ng-container
      *ngTemplateOutlet="
        view;
        context: {
          config: config,
          columnIds: columnIds,
          selectAllCheckbox: selectAllCheckbox,
          isIndeterminate$: isIndeterminate$,
          allRowsSelected$: allRowsSelected$,
          selection: selection,
          singleAction: singleAction,
          multipleActions: multipleActions,
        }
      "
    >
    </ng-container>
  </div>

  <div [hidden]="true">
    <mat-paginator
      #paginatorElement
      [style.width]="config.wrapperWidth"
      [style.height]="config.wrapperHeight"
      [pageSize]="100"
    >
    </mat-paginator>
  </div>
</div>

<agr-notification-empty
  data-test="table__empty"
  *ngIf="(isEmpty === undefined && !config.dataSource?.filteredData?.length) || !!isEmpty"
  [isEmpty]="(isEmpty === undefined && !config.dataSource?.filteredData?.length) || !!isEmpty"
  [emptyTitle]="emptyTitle"
  [emptyDescription]="emptyDescription"
  [emptyImage]="emptyImage"
  [emptyActionIcon]="emptyActionIcon"
  [emptyActionText]="emptyActionText"
  [emptyActionColor]="emptyActionColor"
  [showEmptyAction]="showEmptyAction"
  (emptyAction)="emptyAction.emit($event)"
  class="spacing--margin-top"
></agr-notification-empty>
